import RouterLink from '@components/RouterLink';
import { Divider } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useTranslation } from 'react-i18next';
import AuthWrapper from './AuthWrapper';
import AuthLogin from './auth-forms/LoginForm';
import SAML, { msalConfig } from './auth-forms/SAML';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

// ================================|| LOGIN ||================================ //
export function Component() {
    const { t, i18n } = useTranslation();
    const msalInstance = new PublicClientApplication(msalConfig);

    //https://eye-able.com/de/gratis-wcag-bitv-test
    console.log('lang', i18n.resolvedLanguage);
    const link =
        i18n.resolvedLanguage === 'de'
            ? 'https://eye-able.com/de/gratis-wcag-bitv-test'
            : `https://eye-able.com/free-wcag-test`;

    return (
        <AuthWrapper title={t('loginTitle')}>
            <Grid
                container
                spacing={2}
                sx={{
                    alignItems: 'center'
                }}
            >
                <Grid size={12}>
                    <AuthLogin />

                    <Divider sx={{ mt: 3.5, mb: 3, mx: 2 }} />

                    <MsalProvider instance={msalInstance}>
                        <SAML />
                    </MsalProvider>

                    <Divider sx={{ mt: 3.5, mb: 3, mx: 2 }} />

                    <RouterLink sx={{ textDecoration: 'underline' }} to={link}>
                        {t('noAccountTryEyeAble')}
                    </RouterLink>
                </Grid>
            </Grid>
        </AuthWrapper>
    );
}
